<template>
	<u-animate-container>
		<div class="investors">
			<div class="container-fluid pb-5 container-top">
				<div class="container p-0">
					<b-row>
						<b-col cols="12" class="text-center pt-5 mt-5 p-0">
				    		<h1 class="section-title">{{configs['investors_title']}}</h1>
							<b-col md="8" offset-md="2">
								<p v-html="configs['investors_welcome_txt']"></p>
							</b-col>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="container content position-relative space-to-footer">
				<u-animate
			      name="fadeInUp"
				  :offset="0"
				  delay="0s" 
			      duration="1.2"
				  :begin="true" 
			      :iteration="1"
			    >
					<b-row>
						<b-col cols="12">
								<div :class="themes[0].opened ? 'opened' : ''" class="">
									<div v-on:click="themes[0].opened = !themes[0].opened" class="m-0">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[0].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[0].opened) ? themes[0].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[0].component" v-bind:params="themes[0].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="12">
								<div :class="themes[1].opened ? 'opened' : ''" class="">
									<div v-on:click="themes[1].opened = !themes[1].opened" class="mt-4">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[1].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[1].opened) ? themes[1].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[1].component" v-bind:params="themes[1].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="12">
								<div :class="themes[2].opened ? 'opened' : ''" class="mt-4">
									<div v-on:click="themes[2].opened = !themes[2].opened" class="m-0">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[2].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[2].opened) ? themes[2].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[2].component" v-bind:params="themes[2].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col md="6" class="pr-md-4">
								<div :class="themes[3].opened ? 'opened' : ''" class="">
									<div v-on:click="themes[3].opened = !themes[3].opened" class="mt-4">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[3].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[3].opened) ? themes[3].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[3].component" v-bind:params="themes[3].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>

						<b-col md="6" class="pl-md-4">
								<div :class="themes[4].opened ? 'opened' : ''">
									<div v-on:click="themes[4].opened = !themes[4].opened" class="mt-4">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[4].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[4].opened) ? themes[4].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[4].component" v-bind:params="themes[4].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="12">
								<div :class="themes[5].opened ? 'opened' : ''" class="mt-4">
									<div v-on:click="themes[5].opened = !themes[5].opened" class="m-0">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[5].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[5].opened) ? themes[5].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[5].component" v-bind:params="themes[5].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col cols="12">
								<div :class="themes[6].opened ? 'opened' : ''" class="mt-4">
									<div v-on:click="themes[6].opened = !themes[6].opened" class="m-0">
										<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
											{{themes[6].title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
										</h3>
									</div>
									<div class="ani-height-container mt-2" :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((themes[6].opened) ? themes[6].height : 0) +'px;'">
										<div class="container pb-5">
											<b-row>
												<b-col class="p-0">
													<component :is="themes[6].component" v-bind:params="themes[6].params"></component>
												</b-col>
											</b-row>
										</div>
									</div>
								</div>
						</b-col>
					</b-row>
				</u-animate>
			</div>
			<Footer></Footer>
		</div>
	</u-animate-container>
</template>
<script>

export default {
  name: 'investors',
  components: {
	InvestorInfo: () => import('@/components/investors/InvestorInfo.vue'),
	Report: () => import('@/components/investors/Report.vue'),
	GeneralMeeting: () => import('@/components/investors/GeneralMeeting.vue'),
	CorpGovernance: () => import('@/components/investors/CorpGovernance.vue'),
	Stocks: () => import('@/components/investors/Stocks.vue'),
	Statues: () => import('@/components/investors/Statues.vue'),
	History: () => import('@/components/investors/History.vue'),
  },
  data() {
  	return {
		/*active_idx: -1,*/
  		themes: this.configs['investors_themes']
  	}
  },
  methods: {

  },
  /*computed: {
		opened_items: function() {
			return this.active_idx > -1;
		}	
  }*/
	created: function() {
		
	}
}
</script>
<style scoped>
.container-top {
	background-image: url('../assets/images/003Background_InvestShareholders.jpg');
}
.rotate-icon {
	overflow: hidden;
	transition: all 0.3s ease-in-out;
	transform: rotate(-90deg);
	top: -5px;
    -webkit-transform: rotate(-90deg);
}
.opened .rotate-icon {
	transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
	/*font-size: 22px;*/
}
.ani-height-container {
	/*-webkit-transition: max-height .6s ease-in-out;
	-moz-transition: max-height .6s ease-in-out;
	-ms-transition: max-height .6s ease-in-out;
	-o-transition: max-height .6s ease-in-out;*/
	transition: max-height .4s ease-in-out;
    overflow: hidden;
}
.no_animate.ani-height-container {
	transition: all 0s ease-in-out;
}
/*.opened .ani-height-container {
	max-height: 800px;
}*/
/*@media screen and (max-width:767.98px) {
    .rotate-icon {
		
	}
}*/
</style>
<style>
.about-avatar {
	width: 100%;
	max-width: 80px;
	display: inline-block;
}
@media screen and (max-width:767.98px) {
    .about-avatar {
		max-width: 60px;
	}
}
</style>